import { useState } from 'react';
import PublicNav from '../components/layout/PublicNav';
import PublicFooter from '../components/layout/PublicFooter';

const FAQS = [
  { q: 'How fast can I get a loan?', a: 'Most loan decisions are made within minutes of completing your KYC, and approved funds are disbursed within 24 hours.' },
  { q: 'Is my personal and financial data safe?', a: 'Yes — all data is protected with 256-bit encryption, and we never share your information without consent.' },
  { q: 'What is a Trust Score and how does it affect me?', a: 'Trust Score reflects your repayment and contribution history. A higher score unlocks better loan terms, larger contribution limits, and features like Plan Advance.' },
  { q: 'How does Group Ajo (rotating contributions) work?', a: 'You join or create a group with a fixed contribution amount and cycle. Each cycle, one member receives the full pot in rotation until every member has been paid.' },
  { q: 'What happens if I miss a repayment or contribution?', a: 'A grace period applies before any penalty. Missed payments are flagged, may affect your Trust Score, and repeated misses can affect eligibility for future credit.' },
  { q: 'How do I contact support?', a: 'Use the Contact Us page to reach our support team directly, or check your in-app Support section once logged in.' },
];

function FaqItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 14, overflow: 'hidden' }}>
      <button
        onClick={() => setOpen(o => !o)}
        style={{
          width: '100%', textAlign: 'left', padding: '1.1rem 1.4rem',
          background: 'none', border: 'none', cursor: 'pointer',
          display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '1rem',
          fontSize: '0.95rem', fontWeight: 700, color: 'var(--text-1)',
        }}
      >
        {q}
        <span style={{ color: 'var(--primary)', fontSize: '1.1rem', flexShrink: 0, transform: open ? 'rotate(45deg)' : 'none', transition: 'transform .2s' }}>+</span>
      </button>
      {open && (
        <div style={{ padding: '0 1.4rem 1.1rem', fontSize: '0.85rem', color: 'var(--text-2)', lineHeight: 1.65 }}>
          {a}
        </div>
      )}
    </div>
  );
}

export default function Faqs() {
  return (
    <div style={{ background: 'transparent', color: 'var(--text-1)', minHeight: '100vh', fontFamily: 'Inter, sans-serif', display: 'flex', flexDirection: 'column' }}>
      <PublicNav />

      <main style={{ flex: 1 }}>

      <section style={{ padding: '4.5rem 5% 2.5rem', textAlign: 'center' }}>
        <div style={{ fontSize: '0.7rem', fontWeight: 700, color: '#F5A623', textTransform: 'uppercase', letterSpacing: '0.12em', marginBottom: '0.75rem' }}>FAQs</div>
        <h1 style={{ fontSize: 'clamp(1.8rem,3.5vw,2.6rem)', fontWeight: 900, fontFamily: 'Space Grotesk, sans-serif', letterSpacing: '-0.02em' }}>
          Frequently Asked Questions
        </h1>
      </section>

      <section style={{ padding: '0 5% 5rem' }}>
        <div style={{ maxWidth: 760, margin: '0 auto', display: 'grid', gap: '0.75rem' }}>
          {FAQS.map(f => <FaqItem key={f.q} {...f} />)}
        </div>
      </section>

      </main>

      <PublicFooter />
    </div>
  );
}
